import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/vi";

dayjs.extend(customParseFormat);
dayjs.locale("vi");

const DEFAULT_FORMAT = "DD/MM/YYYY";

export const safeParseDate = (value) => {
  if (!value) return null;

  // Trường hợp: người dùng nhập kiểu DD/MM/YYYY
  let d = dayjs(value, DEFAULT_FORMAT, true);
  if (d.isValid()) return d;

  // Trường hợp: ISO string (YYYY-MM-DDTHH:mm:ssZ)
  d = dayjs(value);
  if (d.isValid()) return d;

  return null; // fallback nếu vẫn không parse được
};

// const date = dayjs("01/06/2025", "DD/MM/YYYY", true); // strict parse
// console.log(date.format("DD/MM/YYYY")); // 01/06/2025
